import { useNavigate } from "react-router-dom";
import { Button } from "@/components/atoms";

/** Fixed bottom CTA on the client home (tablet/mobile only) — opens the booking sheet. */
export const BookATripMobileButton = () => {
  const navigate = useNavigate();
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white px-5 py-3 lg:hidden">
      <Button variant="primary" size="md" className="w-full" onClick={() => navigate("/client/booking")}>
        Book a Trip
      </Button>
    </div>
  );
};
